export default __webpack_public_path__ + "images/c417fdaa8a680a4bda8c5eccf6de175a.svg";